import type { FC } from 'react';
import { useState } from 'react';
import type { pdfjs } from 'react-pdf';
import type { PanelPlacement } from '@ContractBuilder/hooks';

import { LivePDFPreviewDocument } from '../views/LivePDFPreviewDocument';

interface LivePDFPreviewControllerProps {
  documentUrl?: string;
  documentVersion?: number;
  expectedVersion?: number;
  isScanPending?: boolean;
  onDownload: () => Promise<void>;
  pageWidth: number;
  placement: PanelPlacement;
}

export const LivePDFPreviewController: FC<LivePDFPreviewControllerProps> = ({
  documentUrl,
  documentVersion,
  expectedVersion,
  isScanPending = false,
  onDownload,
  pageWidth,
  placement,
}) => {
  'use memo';
  const [pagesState, setPagesState] = useState<{ url: string | undefined; pages: number[] }>({
    url: undefined,
    pages: [],
  });
  const pages = pagesState.url === documentUrl ? pagesState.pages : [];
  const isUpdating = Boolean(documentVersion && expectedVersion && documentVersion < expectedVersion);

  const onDocumentLoadSuccess = (newPdf: pdfjs.PDFDocumentProxy) => {
    const { numPages } = newPdf;
    const newPages = new Array(numPages).fill(0).map((_, idx) => idx + 1);

    setPagesState({ url: documentUrl, pages: newPages });
  };

  return (
    <LivePDFPreviewDocument
      documentVersion={documentVersion}
      expectedVersion={expectedVersion}
      fileUrl={documentUrl}
      isUpdating={isUpdating || isScanPending}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      onDownload={onDownload}
      pages={pages}
      pageWidth={pageWidth}
      placement={placement}
    />
  );
};
